var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"wx_loading",attrs:{"id":"wxloading"}},[_c('div',{staticClass:"wx_loading_inner"},[_c('i',{staticClass:"wx_loading_icon"}),_vm._v(_vm._s(_vm.$t("other.loading"))+"... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }